import { URL_LABEL } from "../../../../../content/index.content";

const keywordSearch = ({ language, isSavedUser }) => {
  return {
    title: "Keyword Search for Amazon",
    subtitle:
      "Scout keywords with high demand, but low competition to optimize your product pages",
    href: isSavedUser
      ? `/app/#/keywords/?${URL_LABEL}`
      : `/amazon-keyword-tools/?${URL_LABEL}`,
    isLink: !isSavedUser,
  };
};

export default keywordSearch;
